/**
 * Invalidate on buyer country / currency / pricing strategy change.
 * Price map args omit those settings; not branch-scoped (skip on `active_branch`).
 * Keep aligned with `providesTags` in sourcing/api.ts.
 */
export const SOURCING_CONTEXT_CACHE_TAGS = ['SourcingPriceMap'] as const;
